<!-- reservation-modal.component.html -->
<div class="reservation-modal">
    <div class="modal-header">
        <h2 mat-dialog-title>{{ isEditMode ? 'Editar Reserva' : 'Nueva Reserva' }}</h2>
        <button mat-icon-button (click)="onCancel()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="modal-content">
        <div class="modal-sections">
            <!-- SECCIÓN: CLIENTE -->
            <div class="section client-section">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>person</mat-icon>
                        <h3>Cliente de la Reserva</h3>
                    </div>
                    <span class="badge badge-success" *ngIf="client">Cliente Asignado</span>
                </div>

                <!-- Cliente seleccionado -->
                <div class="client-card" *ngIf="client">
                    <div class="client-info">
                        <p class="client-name">{{ client.given_name || client.givenName }} {{ client.family_name || client.familyName }}</p>
                        <p class="client-detail">{{ client.email }}</p>
                        <p class="client-detail">{{ client.document_number }}</p>
                    </div>
                    <button mat-button color="warn" (click)="removeClient()">
                        Cambiar Cliente
                    </button>
                </div>

                <!-- Búsqueda/Creación de cliente -->
                <mat-tab-group *ngIf="!client" class="client-tabs">
                    <mat-tab label="Buscar Cliente">
                        <div class="tab-content">
                            <form [formGroup]="clientSearchForm" class="search-form">
                                <mat-form-field class="full-width">
                                    <mat-label>Email del Cliente</mat-label>
                                    <input matInput type="email" formControlName="email"
                                        placeholder="cliente@example.com">
                                    <mat-icon matPrefix>email</mat-icon>
                                </mat-form-field>

                                <mat-form-field class="full-width">
                                    <mat-label>Número de Documento</mat-label>
                                    <input matInput formControlName="document_number" placeholder="1234567890">
                                    <mat-icon matPrefix>badge</mat-icon>
                                </mat-form-field>

                                <button mat-raised-button color="primary" (click)="handleSearchClient()"
                                    class="full-width">
                                    <mat-icon>search</mat-icon>
                                    Buscar Cliente
                                </button>
                            </form>
                        </div>
                    </mat-tab>

                    <mat-tab label="Crear Cliente">
                        <div class="tab-content">
                            <form [formGroup]="clientCreateForm" class="create-form">
                                <div class="form-row">
                                    <mat-form-field class="form-field-half">
                                        <mat-label>Email *</mat-label>
                                        <input matInput type="email" formControlName="email"
                                            placeholder="cliente@example.com">
                                        <mat-icon matPrefix>email</mat-icon>
                                        <mat-error *ngIf="clientCreateForm.get('email')?.hasError('required')">
                                            El email es requerido
                                        </mat-error>
                                        <mat-error *ngIf="clientCreateForm.get('email')?.hasError('email')">
                                            Email inválido
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field class="form-field-half">
                                        <mat-label>Nombres *</mat-label>
                                        <input matInput formControlName="given_name" placeholder="Juan Carlos">
                                        <mat-icon matPrefix>person</mat-icon>
                                    </mat-form-field>
                                </div>

                                <div class="form-row">
                                    <mat-form-field class="form-field-half">
                                        <mat-label>Apellidos *</mat-label>
                                        <input matInput formControlName="family_name" placeholder="Pérez García">
                                        <mat-icon matPrefix>person</mat-icon>
                                    </mat-form-field>

                                    <mat-form-field class="form-field-half">
                                        <mat-label>Tipo de Documento *</mat-label>
                                        <mat-select formControlName="document_type">
                                            <mat-option *ngFor="let type of ID_TYPES" [value]="type">
                                                {{ type }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="form-row">
                                    <mat-form-field class="form-field-half">
                                        <mat-label>Número de Documento *</mat-label>
                                        <input matInput formControlName="document_number" placeholder="1234567890">
                                        <mat-icon matPrefix>badge</mat-icon>
                                    </mat-form-field>

                                    <mat-form-field class="form-field-half">
                                        <mat-label>Contraseña *</mat-label>
                                        <input matInput type="password" formControlName="password" placeholder="••••••">
                                        <mat-icon matPrefix>lock</mat-icon>
                                        <mat-error *ngIf="clientCreateForm.get('password')?.hasError('minlength')">
                                            Mínimo 6 caracteres
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <mat-form-field class="full-width">
                                    <mat-label>Confirmar Contraseña *</mat-label>
                                    <input matInput type="password" formControlName="confirmPassword"
                                        placeholder="••••••">
                                    <mat-icon matPrefix>lock</mat-icon>
                                    <mat-error *ngIf="clientCreateForm.hasError('passwordMismatch')">
                                        Las contraseñas no coinciden
                                    </mat-error>
                                </mat-form-field>

                                <button mat-raised-button color="primary" (click)="handleCreateClient()"
                                    class="full-width">
                                    <mat-icon>person_add</mat-icon>
                                    Crear Cliente
                                </button>
                            </form>
                        </div>
                    </mat-tab>
                </mat-tab-group>
                                    <!-- 🔐 VERIFICACIÓN DE EMAIL -->
        <div class="verification-section" *ngIf="showVerificationStep">
          <h3>Verificación de correo</h3>
          <p>
            Hemos enviado un código de verificación al correo
            <strong>{{ clientPendingVerification?.email }}</strong>
          </p>

          <form [formGroup]="verificationForm">
            <mat-form-field class="full-width">
              <mat-label>Código de verificación</mat-label>
              <input matInput formControlName="code" maxlength="6">
              <mat-icon matPrefix>vpn_key</mat-icon>
            </mat-form-field>

            <button
              mat-raised-button
              color="primary"
              class="full-width"
              (click)="confirmVerificationCode()"
            >
              Confirmar código
            </button>
          </form>

          <div class="error-message" *ngIf="verificationError">
            <mat-icon>error</mat-icon>
            {{ verificationError }}
          </div>
        </div>

                <div class="error-message" *ngIf="clientError">
                    <mat-icon>error_outline</mat-icon>
                    <span>{{ clientError }}</span>
                </div>
            </div>

            <!-- SECCIÓN: SELECCIÓN DE ALOJAMIENTO -->
            <div class="section accommodation-section">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>hotel</mat-icon>
                        <h3>Seleccionar Alojamiento</h3>
                    </div>
                </div>

                <form [formGroup]="reservationForm">
                    <mat-form-field class="full-width">
                        <mat-label>Alojamiento *</mat-label>
                        <mat-select [formControl]="accommodationCtrl">
                            <mat-option *ngFor="let accommodation of accommodations" [value]="accommodation.id">
                                {{ accommodation.name }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matPrefix>business</mat-icon>
                    </mat-form-field>
                </form>
            </div>

            <!-- SECCIÓN: BÚSQUEDA DE DISPONIBILIDAD -->
            <div class="section reservation-section">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>search</mat-icon>
                        <h3>Búsqueda de Disponibilidad</h3>
                    </div>
                </div>

                <form [formGroup]="searchAvailabilityForm" class="reservation-form">
                    <div class="form-row">
                        <mat-form-field class="form-field-half">
                            <mat-label>Check-in *</mat-label>
                            <input matInput type="date" formControlName="check_in">
                        </mat-form-field>

                        <mat-form-field class="form-field-half">
                            <mat-label>Check-out *</mat-label>
                            <input matInput type="date" formControlName="check_out">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-field-third">
                            <mat-label>Adultos *</mat-label>
                            <input matInput type="number" min="1" formControlName="adults">
                        </mat-form-field>

                        <mat-form-field class="form-field-third">
                            <mat-label>Niños</mat-label>
                            <input matInput type="number" min="0" formControlName="children">
                        </mat-form-field>

                        <mat-form-field class="form-field-third">
                            <mat-label>Habitaciones</mat-label>
                            <input matInput type="number" min="1" formControlName="rooms">
                        </mat-form-field>
                    </div>

                    <div class="search-info" *ngIf="searchAvailabilityForm.valid">
                        <mat-icon>info</mat-icon>
                        <span>Buscando para {{ getTotalPeople() }} persona(s) en {{ searchAvailabilityForm.get('rooms')?.value }} habitación(es)</span>
                    </div>

                    <button
                        mat-raised-button
                        color="primary"
                        class="full-width"
                        (click)="searchAvailability()"
                        [disabled]="!selectedAccommodation || searchAvailabilityForm.invalid"
                    >
                        <mat-icon>search</mat-icon>
                        Buscar Disponibilidad
                    </button>
                </form>
            </div>

            <!-- 🆕 SECCIÓN: SUGERENCIAS DE ACOMODACIÓN -->
            <div class="section suggestions-section" *ngIf="showSuggestions && roomSuggestions.length > 0">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>lightbulb</mat-icon>
                        <h3>Opciones de Acomodación Sugeridas</h3>
                    </div>
                    <span class="badge badge-info">{{ roomSuggestions.length }} opciones</span>
                </div>

                <div class="suggestions-container">
                    <div
                        *ngFor="let suggestion of roomSuggestions; let i = index"
                        class="suggestion-card"
                        [class.selected]="isSuggestionSelected(suggestion)"
                        [class.invalid]="!suggestion.isValid"
                        (click)="selectSuggestion(suggestion)"
                    >
                        <div class="suggestion-number">
                            {{ i + 1 }}
                        </div>

                        <div class="suggestion-content">
                            <div class="suggestion-header">
                                <mat-icon *ngIf="suggestion.isValid" class="valid-icon">check_circle</mat-icon>
                                <mat-icon *ngIf="!suggestion.isValid" class="invalid-icon">cancel</mat-icon>
                                <span class="suggestion-status">
                                    {{ suggestion.isValid ? 'Disponible' : 'Capacidad Insuficiente' }}
                                </span>
                            </div>

                            <p class="suggestion-message">{{ suggestion.message }}</p>

                            <div class="suggestion-details">
                                <div class="detail-item">
                                    <mat-icon>people</mat-icon>
                                    <span>Capacidad: {{ suggestion.totalCapacity }} personas</span>
                                </div>
                                <div class="detail-item">
                                    <mat-icon>hotel</mat-icon>
                                    <span>{{ suggestion.rooms.length }} habitación(es)</span>
                                </div>
                                <div class="detail-item price">
                                    <mat-icon>attach_money</mat-icon>
                                    <span class="price-value">{{ formatCurrency(suggestion.totalPrice) }} / noche</span>
                                </div>
                            </div>

                            <!-- Detalle de habitaciones -->
                            <div class="rooms-detail" *ngIf="suggestion.rooms.length > 0">
                                <div class="room-chip" *ngFor="let room of suggestion.rooms">
                                    <mat-icon>meeting_room</mat-icon>
                                    <span>{{ room.name }}</span>
                                    <span class="room-capacity">({{ room.capacity }} pers.)</span>
                                </div>
                            </div>
                        </div>

                        <div class="suggestion-action">
                            <mat-icon *ngIf="isSuggestionSelected(suggestion)" class="selected-icon">
                                radio_button_checked
                            </mat-icon>
                            <mat-icon *ngIf="!isSuggestionSelected(suggestion)" class="unselected-icon">
                                radio_button_unchecked
                            </mat-icon>
                        </div>
                    </div>

                    <!-- Mensaje cuando no hay sugerencias válidas -->
                    <div class="no-suggestions" *ngIf="noRoomSuggestions">
                        <mat-icon>warning</mat-icon>
                        <p>No se encontraron opciones que cumplan con los requisitos de capacidad.</p>
                        <p class="suggestion-hint">Intente ajustar el número de habitaciones o la cantidad de personas.</p>
                    </div>
                </div>
            </div>

            <!-- SECCIÓN: HABITACIONES SELECCIONADAS -->
            <div class="section selected-rooms-section" *ngIf="selectedRooms.length > 0">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>check_circle</mat-icon>
                        <h3>Habitaciones Seleccionadas</h3>
                    </div>
                    <span class="badge badge-success">{{ selectedRooms.length }} seleccionada(s)</span>
                </div>

                <div class="selected-rooms-list">
                    <div class="selected-room-item" *ngFor="let room of selectedRooms">
                        <div class="room-icon">
                            <mat-icon>meeting_room</mat-icon>
                        </div>
                        <div class="room-details">
                            <p class="room-name">{{ room.name }}</p>
                            <p class="room-info">
                                <span>Capacidad: {{ room.capacity }} personas</span>
                                <span class="separator">•</span>
                                <span>{{ formatCurrency(room.price_per_night) }} / noche</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SECCIÓN: SERVICIOS EXTRAS -->
            <div class="section services-section" *ngIf="extraServices.length > 0">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>shopping_cart</mat-icon>
                        <h3>Servicios Extras</h3>
                    </div>
                </div>

                <div class="services-list">
                    <div class="service-item" *ngFor="let service of extraServices">
                        <div class="service-info">
                            <p class="service-name">{{ service.name }}</p>
                            <p class="service-price">{{ formatCurrency(service.cost) }} por unidad</p>
                        </div>
                        <div class="service-controls">
                            <button mat-icon-button (click)="decrementService(service.id)"
                                [disabled]="service.quantity === 0">
                                <mat-icon>remove</mat-icon>
                            </button>
                            <span class="service-quantity">{{ service.quantity }}</span>
                            <button mat-icon-button (click)="incrementService(service.id)">
                                <mat-icon>add</mat-icon>
                            </button>
                            <span class="service-total">{{ formatCurrency(getServiceTotal(service)) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SECCIÓN: RESUMEN DE COSTOS -->
            <div class="section summary-section">
                <div class="section-header">
                    <div class="section-title">
                        <mat-icon>attach_money</mat-icon>
                        <h3>Resumen de Costos</h3>
                    </div>
                </div>

                <div class="cost-summary">
                    <div class="cost-item">
                        <span class="cost-label">Habitación(es):</span>
                        <span class="cost-value">
                            <ng-container *ngIf="selectedRooms.length > 0">
                                {{ formatCurrency(selectedRoomsTotal) }} × {{ calculateNights() }} noche(s)
                            </ng-container>
                            <ng-container *ngIf="selectedRooms.length === 0 && getSelectedRoom()">
                                {{ formatCurrency(getSelectedRoom()?.price_per_night || 0) }} × {{ calculateNights() }} noche(s)
                            </ng-container>
                        </span>
                    </div>

                    <div class="cost-item cost-room-total">
                        <span class="cost-label">Total habitaciones:</span>
                        <span class="cost-value">{{ formatCurrency(calculateRoomTotal()) }}</span>
                    </div>

                    <div class="cost-item" *ngIf="calculateServicesTotal() > 0">
                        <span class="cost-label">Servicios adicionales:</span>
                        <span class="cost-value">{{ formatCurrency(calculateServicesTotal()) }}</span>
                    </div>

                    <div class="cost-divider"></div>

                    <div class="cost-item cost-subtotal">
                        <span class="cost-label">Subtotal:</span>
                        <span class="cost-value">{{ formatCurrency(calculateSubtotal()) }}</span>
                    </div>

                    <div class="cost-item cost-total">
                        <span class="cost-label">Total:</span>
                        <span class="cost-value">{{ formatCurrency(calculateTotal()) }}</span>
                    </div>

                    <div class="cost-divider"></div>

                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="modal-actions">
        <button mat-button (click)="onCancel()" class="cancel-button">
            Cancelar
        </button>
        <button mat-raised-button color="primary" (click)="handleSubmit()" class="submit-button">
            {{ isEditMode ? 'Actualizar Reserva' : 'Crear Reserva' }}
        </button>
    </mat-dialog-actions>
</div>
